module.exports = __webpack_public_path__ + "img/lecture2-pc.c37e75a0.png";